import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import FormSpinner from '../../../../../components/FormSpinner';
import { RMSButton } from '../../buttons/index';

const ConfirmationDialog = ({ open, title, message, onYes, onNo, loading }) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      {loading && <FormSpinner />}
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography>{message}</Typography>
      </DialogContent>

      <DialogActions>
        <RMSButton label="Yes" onClick={onYes}></RMSButton>
        <RMSButton label="No" onClick={onNo} color="secondary"></RMSButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
